const modal = document.getElementById('service-modal');
const openButton = document.querySelector('[data-open-modal]');
const closeButtons = document.querySelectorAll('[data-close-modal]');
const form = document.querySelector('.service-form');

const openModal = () => {
  if (!modal) return;
  modal.classList.add('open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
};

const closeModal = () => {
  if (!modal) return;
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
};

openButton?.addEventListener('click', openModal);
closeButtons.forEach((button) => button.addEventListener('click', closeModal));

modal?.addEventListener('click', (event) => {
  if (event.target === modal) {
    closeModal();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeModal();
  }
});

form?.addEventListener('submit', (event) => {
  event.preventDefault();

  const formData = new FormData(form);
  const data = {
    firstName: formData.get('firstName') || '',
    lastName: formData.get('lastName') || '',
    phone: formData.get('phone') || '',
    email: formData.get('email') || '',
    siteAddress: formData.get('siteAddress') || '',
    street: formData.get('street') || '',
    city: formData.get('city') || '',
    state: formData.get('state') || '',
    zip: formData.get('zip') || '',
    request: formData.get('request') || '',
  };

  const subject = encodeURIComponent('Petro-Lubes Quick Service Request');
  const body = encodeURIComponent(
    `First Name: ${data.firstName}\nLast Name: ${data.lastName}\nPhone: ${data.phone}\nEmail: ${data.email}\nSite Address: ${data.siteAddress}\nStreet: ${data.street}\nCity: ${data.city}\nState: ${data.state}\nZip Code: ${data.zip}\n\nService Request Information:\n${data.request}`
  );
  const mailtoLink = `mailto:Petrolubesenterprise@gmail.com?subject=${subject}&body=${body}`;

  window.location.href = mailtoLink;

  const submitButton = form.querySelector('.btn-submit');
  if (submitButton) {
    submitButton.textContent = 'Request Sent';
    submitButton.disabled = true;
  }

  window.setTimeout(() => {
    form.reset();
    if (submitButton) {
      submitButton.textContent = 'Submit Request';
      submitButton.disabled = false;
    }
    closeModal();
  }, 1200);
});

const dropdownTrigger = document.querySelector('.menu-trigger');
const dropdownPanel = document.getElementById('service-menu');
const navToggle = document.querySelector('.nav-toggle');
const navMenu = document.querySelector('.nav-menu');
const actionToggle = document.querySelector('[data-action-toggle]');
const actionPopup = document.getElementById('service-action-popup');

const closeDropdown = () => {
  if (!dropdownTrigger || !dropdownPanel) return;
  dropdownTrigger.setAttribute('aria-expanded', 'false');
  dropdownPanel.classList.remove('open');
};

const toggleDropdown = () => {
  if (!dropdownTrigger || !dropdownPanel) return;
  const isOpen = dropdownPanel.classList.toggle('open');
  dropdownTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
};

const toggleNavMenu = () => {
  if (!navToggle || !navMenu) return;
  const isOpen = navMenu.classList.toggle('open');
  navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
};

const closeActionPopup = () => {
  if (!actionPopup || !actionToggle) return;
  actionPopup.classList.remove('open');
  actionToggle.setAttribute('aria-expanded', 'false');
};

const toggleActionPopup = () => {
  if (!actionPopup || !actionToggle) return;
  const isOpen = actionPopup.classList.toggle('open');
  actionToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
};

dropdownTrigger?.addEventListener('click', (event) => {
  event.stopPropagation();
  toggleDropdown();
});

navToggle?.addEventListener('click', () => {
  toggleNavMenu();
  closeDropdown();
  closeActionPopup();
});

actionToggle?.addEventListener('click', (event) => {
  event.stopPropagation();
  toggleActionPopup();
  closeDropdown();
});

const runServiceAction = (action) => {
  const supportNumber = '+17082055429';
  const subject = encodeURIComponent('Petro-Lubes Quick Service Request');
  const body = encodeURIComponent('Please contact me about my service request.');

  if (action === 'call') {
    window.location.href = `tel:${supportNumber}`;
  } else if (action === 'text') {
    window.location.href = `sms:${supportNumber}?body=${body}`;
  } else if (action === 'email') {
    window.location.href = `mailto:Petrolubesenterprise@gmail.com?subject=${subject}&body=${body}`;
  }
};

document.addEventListener('click', (event) => {
  if (!dropdownPanel?.contains(event.target) && !dropdownTrigger?.contains(event.target)) {
    closeDropdown();
  }

  if (!actionPopup?.contains(event.target) && !actionToggle?.contains(event.target)) {
    closeActionPopup();
  }

  if (!navMenu?.contains(event.target) && !navToggle?.contains(event.target)) {
    navMenu?.classList.remove('open');
    navToggle?.setAttribute('aria-expanded', 'false');
  }
});

dropdownPanel?.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', () => {
    closeDropdown();
    navMenu?.classList.remove('open');
    navToggle?.setAttribute('aria-expanded', 'false');
  });
});

actionPopup?.querySelectorAll('[data-action]').forEach((button) => {
  button.addEventListener('click', () => {
    const action = button.getAttribute('data-action');
    if (action) runServiceAction(action);
  });
});
